import { atomWithReset } from 'jotai/utils';
import { EClickPosition } from 'shared/constant';

type TCTAModel =
  | false
  | {
      variant: 'primary' | 'v2';
      clickPosition: EClickPosition;
      clickId?: string;
      onConfirm: () => void;
      onCancel: () => void;
    };

export const $CTAModal = atomWithReset<TCTAModel>(false);
